import React from 'react';
import './Project.css'
import img1 from '../../images/Capture.PNG'
import img2 from '../../images/Capture2.PNG'
import img3 from '../../images/Capture3.PNG'
import { Container } from 'react-bootstrap';

const Project = () => {
    return (
        <div id='projects'>
           <Container>
        <h2 className='mt-3 title'>My Projects_</h2>
        <div className='row project'>
            <div className='col-md-5 px-5' data-aos="zoom-in"
     data-aos-anchor-placement="center-bottom"
     data-aos-duration="500">
                <img className='img-fluid image m-5' src={img1}/>
            </div>
            <div className='col-md-7 '  data-aos="fade-up"
     data-aos-anchor-placement="center-bottom"
     data-aos-duration="500">
                <h3 className='project-title'>❖ Amazing Car House</h3>
                <p className='date'>Nov 2021 - Nov 2021</p>
                <ul>
                    
                    <li>➣ A  fully responsive niche website</li>
                    <li>➣  If  customers are new to create an account and  use browse products, buy products & write reviews.</li>
                    <li>➣  Admins have the ability to add new products, remove existing products, remove user products, and create new admin accounts.</li>
                    

                </ul>
                <ul className='tags'>
         <li>
         #React BootStrap 
         </li>
         <li>
         #JS
         </li>
         <li>
         #React
         </li>
         <li>
         #React Router
         </li>
         <li>
         #Firebase
         </li>
         <li>
         #Heroku
         </li>
         <li>
         #MongoDb
         </li>
     </ul>
         <div className='project-link'>
         <a rel="noreferrer"  href='https://amazing-car-house.web.app/' target='_blank'><i class="fas fa-globe"></i> Live Site</a>
         <a rel="noreferrer"  href='https://github.com/armanh20439/amaging-car' target='_blank'><i class="fab fa-github-square"></i> Client Site</a>
         <a rel="noreferrer"  href='https://github.com/armanh20439/amagin-car-seerver' target='_blank'><i class="fab fa-github-square"></i> Server Site</a>
         </div>
            </div>

        </div>
        {/* 2nd project  */}
        <div className='row project'>
            <div className='col-md-5 px-5' data-aos="zoom-in"
     data-aos-anchor-placement="center-bottom"
     data-aos-duration="500">
                <img className='img-fluid image m-5' src={img2}/>
            </div>
            <div className='col-md-7 '  data-aos="fade-up"
     data-aos-anchor-placement="center-bottom"
     data-aos-duration="500">
                <h3 className='project-title'>❖ Earth Tourism
</h3>
                <p className='date'>Oct 2021 - Oct 2021</p>
                <ul>
                    
                    <li>➣ A  fully responsive Tourism website</li>
                    <li>➣  If  visitor are new to create an account then  use Booking review and remove booking or purchase.</li>
                    <li>➣ User can sign in google Authontication.</li>
                    

                </ul>
                <ul className='tags'>
         <li>
         #React BootStrap 
         </li>
         <li>
         #JS
         </li>
         <li>
         #React
         </li>
         <li>
         #React Router
         </li>
         <li>
         #Firebase
         </li>
         <li>
         #Heroku
         </li>
         <li>
         #MongoDb
         </li>
     </ul>
         <div className='project-link'>
         <a rel="noreferrer"  href='https://assign-11-tourism.web.app/' target='_blank'><i class="fas fa-globe"></i> Live Site</a>
         <a rel="noreferrer"  href='https://github.com/armanh20439/torism-cliant' target='_blank'><i class="fab fa-github-square"></i> Client Site</a>
         <a rel="noreferrer"  href='https://github.com/armanh20439/torism-server' target='_blank'><i class="fab fa-github-square"></i> Server Site</a>
         </div>
            </div>

        </div>
        {/* 3rd project  */}
        <div className='row project'>
            <div className='col-md-5 px-5' data-aos="zoom-in"
     data-aos-anchor-placement="center-bottom"
     data-aos-duration="500">
                <img className='img-fluid image m-5' src={img3}/>
            </div>
            <div className='col-md-7 '  data-aos="fade-up"
     data-aos-anchor-placement="center-bottom"
     data-aos-duration="500">
                <h3 className='project-title'>❖ Ibne sinha hosptal
</h3>
                <p className='date'>Sep 2021 - Sep 2021</p>
                <ul>
                    
                    <li>➣ A  fully responsive Hospital Service  website</li>
                    <li>➣  This website use Data in Json File, Use Firebase For LogIn System.</li>
                    <li>➣ User can sign in google Authontication.</li>
                    

                </ul>
                <ul className='tags'>
         <li>
         #React BootStrap 
         </li>
         <li>
         #JS
         </li>
         <li>
         #React
         </li>
         <li>
         #React Router
         </li>
         <li>
         #Firebase
         </li>
        
     </ul>
         <div className='project-link'>
         <a rel="noreferrer"  href='https://amazing-jennings-e60b6c.netlify.app/' target='_blank'><i class="fas fa-globe"></i> Live Site</a>
         <a rel="noreferrer"  href='https://github.com/armanh20439/assigment-10' target='_blank'><i class="fab fa-github-square"></i> Client Site</a>
         
         </div>
            </div>

        </div>
          
           </Container>
        </div>
    );
};

export default Project;